function IconTalkTimeHighFace() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 0C10.7451 0 0 10.7451 0 24C0 37.2549 10.7451 48 24 48C37.2549 48 48 37.2549 48 24C48 10.7451 37.2549 0 24 0M24.0682 42.2106C12.5139 42.2106 8.04818 36.1163 8.04818 33.022C8.04818 32.1751 8.73389 31.4894 9.58075 31.4894H38.5556C39.4025 31.4894 40.0882 32.1751 40.0882 33.022C40.0882 36.1163 35.6225 42.2106 24.0682 42.2106V42.2106ZM16.4311 15.6377C18.7986 15.6377 20.7186 17.556 20.7186 19.9234C20.7186 22.2908 18.7986 24.2091 16.4311 24.2091C14.0654 24.2091 12.1471 22.2908 12.1471 19.9234C12.1471 17.556 14.0654 15.6377 16.4311 15.6377M31.8595 15.6377C34.2269 15.6377 36.1469 17.556 36.1469 19.9234C36.1469 22.2908 34.2269 24.2091 31.8595 24.2091C29.4938 24.2091 27.5755 22.2908 27.5755 19.9234C27.5755 17.556 29.4938 15.6377 31.8595 15.6377"
        fill="white"
      />
    </svg>
  );
}

export { IconTalkTimeHighFace };
